module.exports = __webpack_public_path__ + "img/spese-easyer.51412abb.png";